module.exports = "./img/45b70eb320a41e9ae41e06ea5f31a1af.jpg";